import React from 'react';

/** Chrome-size glyphs keep 1.4; large glyphs stay ~2.2px on screen. */
const folderStroke = (size) => (size <= 20 ? 1.4 : Math.round((24 / size) * 2.2 * 100) / 100);

/**
 * Geometric folder glyph — stroke, like the rest of the UI chrome.
 * Closed: tab + body. Open: back tab, front flap opening toward the camera.
 */
export const FolderIcon = ({ size = 14, open = false, className }) => {
  const sw = folderStroke(size);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden
      style={{ display: 'block', flexShrink: 0 }}
    >
      {open ? (
        <>
          <path
            d="M3.5 6.7A2.1 2.1 0 0 1 5.6 4.7h3.05L10.3 6.5H18.2A2.1 2.1 0 0 1 20.3 8.6V11H3.5Z"
            fill="currentColor"
            fillOpacity="0.12"
          />
          <path
            d="M3.5 6.7A2.1 2.1 0 0 1 5.6 4.7h3.05L10.3 6.5H18.2A2.1 2.1 0 0 1 20.3 8.6V11"
            stroke="currentColor"
            strokeWidth={sw}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.6 10.6H20.4L21.5 18.3A2.1 2.1 0 0 1 19.4 20.6H4.6A2.1 2.1 0 0 1 2.5 18.3L3.6 10.6Z"
            fill="currentColor"
            fillOpacity="0.22"
            stroke="currentColor"
            strokeWidth={sw}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ) : (
        <>
          <path
            d="M3.5 7.2A2.2 2.2 0 0 1 5.7 5h3.05L10.4 6.8H18.3A2.2 2.2 0 0 1 20.5 9v8.3a2.2 2.2 0 0 1-2.2 2.2H5.7A2.2 2.2 0 0 1 3.5 17.3V7.2Z"
            fill="currentColor"
            fillOpacity="0.2"
          />
          <path
            d="M3.5 7.2A2.2 2.2 0 0 1 5.7 5h3.05L10.4 6.8H18.3A2.2 2.2 0 0 1 20.5 9v8.3a2.2 2.2 0 0 1-2.2 2.2H5.7A2.2 2.2 0 0 1 3.5 17.3V7.2Z"
            stroke="currentColor"
            strokeWidth={sw}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )}
    </svg>
  );
};

// Docs sidebar / menus — same stroke folder
export const FolderStubIcon = ({ size = 14, open = false }) => (
  <FolderIcon size={size} open={open} />
);
